export const SET_FINANCIAL_YEARS_LOADED = "SET_FINANCIAL_YEARS_LOADED";

export const setFinancialYearsLoaded = (financialYearsLoaded: boolean) => {
  return {
    financialYearsLoaded,
    type: SET_FINANCIAL_YEARS_LOADED
  };
};
